import React from 'react';
import { Text, useTranslator } from '@eo-locale/react';
import InputAdornment from '@mui/material/InputAdornment';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { styled } from '@mui/material/styles';
import { useNumberFormatter } from '@guest-widgets/shared/src/hooks/useNumberFormatter';
import { useId } from '@guest-widgets/shared/src/hooks/useId';
import { ids } from '@guest-widgets/shared/src/ids';
import { classes } from '@guest-widgets/shared/src/classes';
import { WithClassName } from '@guest-widgets/shared/src/types/withClassName';
import { usePopupState, bindToggle, bindPopper } from 'material-ui-popup-state/hooks';

import { useFilters } from '../../../filtersContext/filtersContext';
import { RadiusFilter } from '../RadiusFilter';

import { Popper } from './Popper';
import { FilterTextField } from './FilterTextField';

export const Radius = ({ className }: WithClassName) => {
  const translator = useTranslator();
  const { formatKilometers } = useNumberFormatter();
  const sliderAriaLabelId = useId(ids.catalog.radiusFilter);
  const {
    filters: { location },
  } = useFilters();
  const popupState = usePopupState({ variant: 'popper', popupId: 'radius-filters' });

  if (!location) return null;

  return (
    <>
      <StyledTextField
        popupState={popupState}
        className={`${classes.catalog.filters.radius.input} ${className || ''}`}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <ArrowDropDownIcon />
            </InputAdornment>
          ),
        }}
        value={formatKilometers(location.radius)}
        placeholder={translator.translate('product-catalog.filters.radius.placeholder')}
        label={translator.translate('product-catalog.filters.radius.title')}
        {...bindToggle(popupState)}
      />

      <Popper
        className={classes.catalog.filters.radius.root}
        popperTitle={
          <span id={sliderAriaLabelId}>
            <Text id="product-catalog.filters.radius.title" />
          </span>
        }
        placement="bottom-start"
        popupState={popupState}
        {...bindPopper(popupState)}
      >
        <StyledRadiusFilter ariaLabelledBy={sliderAriaLabelId} />
      </Popper>
    </>
  );
};

const StyledTextField = styled(FilterTextField)({
  width: 120,
});

const StyledRadiusFilter = styled(RadiusFilter)({
  width: 300,
});
